import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Page from './Page';
export default function NotFound() {
    return (_jsx(Page, { pageTitle: "404 Not Found", children: _jsx(Container, { children: _jsx("p", { children: "Page Not Found" }) }) }));
}
const Container = styled.div `
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
`;
//# sourceMappingURL=NotFound.js.map